export default __webpack_public_path__ + "09a554110a20aa90889ff984f2c2cd12.png";